import { Card, Divider, notification, Radio, RadioChangeEvent, Typography} from "antd";
import React, {useContext, useState} from "react";
import LegalPersonForm from "../components/register-letter/LegalPersonForm";
import RealPersonForm from "../components/register-letter/RealPersonForm";
import Api from "../utilis/api/service";
import AuthContext from "../utilis/contexts/AuthContext";
import {FaCheckCircle} from "react-icons/fa";
import RegisteredLetterList from "../components/register-letter/RegisteredLetterList"
const {Title} = Typography;
type FormType="Individual" | "Company"
const RegisterLetter=()=> {
    const authContext = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [formType, setFormType] = useState<FormType>("Individual");
    const [success, setSuccess] = useState(false)
    const [traceNumber, setTraceNumber] = useState(null)
    const onChange = (e: RadioChangeEvent) => {
        setFormType(e.target.value as FormType);
    }

    const onConfirm = (data: any) => {
        setLoading(true)
        const params = {
            ...data,
            Cellphone: authContext?.user?.cellphone || '',
            UserType: formType,

        }
        Api.post('/RegisterLetter', params, {
            headers: {
                "Authorization": 'Bearer' + " " + authContext.Token.accessToken
            }
        }).then(response => {

            const {data} = response;
            const {Data, Status, Message} = data;
            if (Status === -1) {
                notification['error']({
                    message: Message,
                    duration: 120
                });
            } else {
                setSuccess(true);
                setTraceNumber(Data.trace_number)
            }
        }).catch(() => {
            notification['error']({
                message: 'خطای ناشناخته',
                duration: 120
            });
        }).finally(() => {
            setLoading(false)
        })
    }
    if (authContext?.user?.is_admin) {
        return <RegisteredLetterList/>
    }

    return <div className="flex flex-col gap-4">
        <Card className="  w-full rounded-xl ">
            <div className="w-full ">

                {success &&
                    <div className="w-full lg:w-6/12 mx-auto flex flex-col gap-4 justify-center items-center">
                        <FaCheckCircle className="text-center text-5xl text-green-500"/>
                        <h1 className="text-green-500 text-center text-lg font-bold">موفق</h1>
                        <p className="text-center">در خواست شما با موفقیت ثبت شد.</p>
                        {traceNumber && <div className="grid grid-cols-1 lg:grid-cols-2 bg-gray-100 rounded  w-full">
                            <span className="p-2 w-full">شناسه رهگیری</span>
                            <span className="border w-full bg-gray-50 p-2">{traceNumber}</span>
                        </div>}

                    </div>}
                {!success && <div className="w-full">
                    <div className="bg-primary mb-4 rounded-xl p-5 bg-opacity-5">
                        <Title level={4}>پیشخوان ارباب رجوع</Title>
                        <Divider/>
                        <Title level={5}>ثبت درخواست</Title>
                        <Typography>جهت ثبت درخواست فرم زیر را تکمیل کنید.</Typography>
                    </div>
                    <Radio.Group size="large" value={formType} onChange={onChange} style={{marginBottom: 26}}>
                        <Radio.Button value="Individual">شخص حقیقی</Radio.Button>
                        <Radio.Button value="Company">شخص حقوقی</Radio.Button>
                    </Radio.Group>
                    {formType === "Individual" && <RealPersonForm loading={loading} onConfirm={onConfirm}/>}
                    {formType == "Company" && <LegalPersonForm loading={loading} onConfirm={onConfirm}/>}


                </div>}
            </div>
        </Card>
    </div>
}
export default RegisterLetter;